import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Initialize Meta Pixel
const PIXEL_ID = '1425901482655593';
const initPixel = () => {
  if (typeof window !== 'undefined') {
    // Standard Meta Pixel Code
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }
};
initPixel();
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<React.StrictMode data-id="element-213">
    <App data-id="element-214" />
  </React.StrictMode>);